//定义mutation用到方法名
//设置用户
export const SET_USER = 'USER'
//


//设置token
export const SET_AUTHORIZATION = 'SET_AUTHORIZATION'

